import React from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainNarrative } from './components/PainNarrative';
import { RealitySection } from './components/RealitySection';
import { TruthSection } from './components/TruthSection';
import { ProductShowcase } from './components/ProductShowcase';
import { TimelineSection } from './components/TimelineSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-orange/30" data-id="element-0">
      <CountdownBanner data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <PainNarrative data-id="element-5" />
        <RealitySection data-id="element-6" />
        <TruthSection data-id="element-7" />
        <ProductShowcase data-id="element-8" />
        <TimelineSection data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <Footer data-id="element-15" />

      <PurchaseToast data-id="element-16" />
    </div>;
}